<template>
  <div ref="userInfoTab">
    <div id="not-img-cropper">
      <div
        ref="profilerow"
        class="vx-row ml-4 vs-con-loading__container"
        id="profilecontainer"
      >
        <div class="vx-col container_profile-pic">
          <img
            id="profileimg"
            src="https://forty5degreesstorage.blob.core.windows.net/user/avatar_default.png"
            width="100%"
          />
        </div>
        <div class="vx-row pb-3 ml-4">
          <div class="vx-col w-full">
            <h2>{{ formData.userFirstName }} {{ formData.userLastName }}</h2>
            <div v-if="formData.email">
              <h5 class="pt-4">
                Email: <strong>{{ formData.email }}</strong>
              </h5>
            </div>
          </div>
        </div>
      </div>
      <vs-divider class="mb-6"></vs-divider>
      <div v-show="false" class="vx-row pb-3">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label>Email</label>
          <vs-input
            autocomplete="off"
            ref="emailInput"
            onClick="this.select();"
            type="required|email"
            v-validate="'email'"
            name="email"
            class="w-full"
            icon-pack="feather"
            icon="icon-at-sign"
            v-model="formData.email"
          />
          <span class="text-danger text-sm" v-show="errors.has('email')">{{
            errors.first("email")
          }}</span>
        </div>
        <div class="vx-col mb-2 mt-8">
          <vs-checkbox v-model="formData.isActive" color="success">Is Active</vs-checkbox>
        </div>
      </div>
      <div class="vx-row pb-3">
        <div class="vx-col sm:w-1/2 w-full mb-2" style="margin-left: 4px">
          <label>First Name</label>
          <vs-input
            autocomplete="off"
            onClick="this.select();"
            class="w-full"
            v-validate="'required|alpha_spaces'"
            name="First Name"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            v-model="formData.userFirstName"
          />
          <span class="text-danger text-sm" v-show="errors.has('First Name')">{{
            errors.first("First Name")
          }}</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2" style="margin-left: 4px">
          <label>Last Name</label>
          <vs-input
            autocomplete="off"
            onClick="this.select();"
            class="w-full"
            v-validate="'required|alpha_spaces'"
            name="Last Name"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            v-model="formData.userLastName"
          />
          <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{
            errors.first("Last Name")
          }}</span>
        </div>
      </div>
      <div class="vx-row pb-3" v-show="currentSiteTypeId == 1">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label>Content Language</label>
          <v-select
            ref="languageDropdown"
            class="w-full"
            placeholder="Search / Select Language"
            :options="languages"
            @search:blur="selectLanguage"
            v-model="languageDropdown"
          ></v-select>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label>Grade</label>
          <v-select
            ref="classificationDropdown"
            class="w-full"
            placeholder="Search / Select Grade"
            :options="classifications"
            v-model="classificationDropdown"
          ></v-select>
        </div>
      </div>
      <!-- Manage Password -->
      <vs-divider class="mb-6 pt-0">Login Credentials</vs-divider>
      <div class="vx-row pb-3">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-checkbox v-model="changePassword">Change Password</vs-checkbox>
        </div>
      </div>
      <div class="vx-row pb-3" v-show="changePassword">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label>Password</label>
          <vs-input
            autocomplete="off"
            onClick="this.select();"
            type="password"
            v-validate="'min:8|max:100'"
            name="password"
            ref="password"
            class="w-full"
            icon-pack="feather"
            icon="icon-lock"
            icon-no-border
            v-model="formData.password"
          />
          <span class="text-danger text-sm" v-show="errors.has('password')">{{
            errors.first("password")
          }}</span>
        </div>
      </div>
      <div class="vx-row pb-3" v-show="changePassword">
        <div class="vx-col sm:w-1/2 w-full mb-2" v-show="formData.password">
          <label>Confirm Password</label>
          <vs-input
            autocomplete="off"
            onClick="this.select();"
            type="password"
            v-validate="'min:8|max:100|confirmed:password'"
            name="confirm_password"
            data-vv-as="password"
            class="w-full"
            icon-pack="feather"
            icon="icon-lock"
            icon-no-border
            v-model="formData.passwordConfirm"
          />
          <span class="text-danger text-sm" v-show="errors.has('confirm_password')">{{
            errors.first("confirm_password")
          }}</span>
        </div>
      </div>
    </div>

    <div v-if="$siteTypeId() != 1">
      <vs-divider class="mb-6 pt-0">Signature</vs-divider>
      <VueSignaturePad
        v-if="showSignaturePad"
        :width="`${currentWindowWidth < 500 ? currentWindowWidth : '500'}px`"
        :height="`${currentWindowWidth < 500 ? currentWindowWidth : '500'}px`"
        ref="signaturePad"
        class="signaturePadStyle"
      />
      <file-pond
          v-show="false"
          id="cover-filepond"
          ref="coverPagePond"
          :server="uploadLocation"
          label-idle="Drop Cover Image file here or <span class='filepond--label-action' text-decoration-color: #aaa>Browse</span>"
          accepted-file-types="image/*"
          :allow-multiple="false"
          allowPaste=false
          :instant-upload="true"
          @processfile="uploadCompleteCover"
        />
      <div class="vx-col cropper-div">
        <div v-if="!showCropImage">
          <input
            ref="input"
            type="file"
            name="image"
            accept="image/*"
            @change="setImage"
          />
          <section class="cropper-area_tool" id="not-img-cropper">
            <div class="img-cropper">
              <vue-cropper
                v-show="formData.signatureImageUrl && newSignatureClicked"
                ref="cropper"
                :src="formData.signatureImageUrl"
                preview=".preview"
              />
            </div>
            <img
              v-if="signature && !newSignatureClicked && !showSignaturePad"
              :src="signature"
              id="signatureimage"
              style="background: white;"
            />
          </section>
          <div class="vx-vol cropper-area_buttons">
            <div class="vx-row ml-0" style="margin: 0" id="not-img-cropper">
              
              <vs-button
            v-if="!showSignaturePad"
            class="mr-5 mt-3"
            icon-pack="feather"
            color="success"
            type="filled"
            icon="icon-upload"
            @click.prevent="enableSignaturePad"
            >Draw New Signature</vs-button>
          <vs-button
            v-show="showSignaturePad"
            class="mr-5 mt-3"
            icon-pack="feather"
            color="success"
            type="filled"
            icon="icon-upload"
            @click.prevent="save"
            >Save New Signature</vs-button>
          <vs-button
            v-show="showSignaturePad"
            class="mr-5 mt-3"
            icon-pack="feather"
            color="warning"
            type="border"
            @click.prevent="showSignaturePad = false;"
            >Cancel</vs-button>

              <vs-button
                v-show="newSignatureClicked"
                class="mr-5 mt-3"
                type="border"
                color="warning"
                icon-pack="feather"
                icon="icon-refenableSignaturePadresh-ccw"
                @click.prevent="reset"
                >Reset</vs-button
              >

              <vs-button
                v-show="newSignatureClicked"
                radius
                class="mr-2 mt-3"
                icon-pack="feather"
                icon="icon-zoom-in"
                @click.prevent="zoom(0.2)"
              />
              <vs-button
                v-show="newSignatureClicked"
                radius
                class="mr-5 mt-3"
                icon-pack="feather"
                icon="icon-zoom-out"
                @click.prevent="zoom(-0.2)"
              />

              <vs-button
                v-show="newSignatureClicked"
                radius
                type="border"
                class="mr-2 mt-3"
                icon-pack="feather"
                icon="icon-arrow-left"
                @click.prevent="move(-10, 0)"
              />
              <vs-button
                v-show="newSignatureClicked"
                radius
                type="border"
                class="mr-2 mt-3"
                icon-pack="feather"
                icon="icon-arrow-right"
                @click.prevent="move(10, 0)"
              />
              <vs-button
                v-show="newSignatureClicked"
                radius
                type="border"
                class="mr-2 mt-3"
                icon-pack="feather"
                icon="icon-arrow-up"
                @click.prevent="move(0, -10)"
              />
              <vs-button
                v-show="newSignatureClicked"
                radius
                type="border"
                class="mr-5 mt-3"
                icon-pack="feather"
                icon="icon-arrow-down"
                @click.prevent="move(0, 10)"
              />

              <vs-button
                v-show="newSignatureClicked"
                radius
                class="mr-2 mt-3"
                icon-pack="feather"
                icon="icon-rotate-cw"
                @click.prevent="rotate(90)"
              />
              <vs-button
                v-show="newSignatureClicked"
                radius
                class="mr-5 mt-3"
                icon-pack="feather"
                icon="icon-rotate-ccw"
                @click.prevent="rotate(-90)"
              />

              <vs-button
                v-show="newSignatureClicked"
                ref="cropButton"
                class="mr-5 mt-3"
                color="success"
                icon-pack="feather"
                icon="icon-crop"
                @click.prevent="cropImage"
                >Crop</vs-button
              >
            </div>
          </div>
        </div>
        <div v-if="showCropImage" id="not-img-cropper">
          <img :src="formData.signatureImageUrl" id="cropsignatureimage" />
          
        </div>
        <p
          id="not-img-cropper"
          v-show="cropImg || showCropImage"
          class="mt-3 text-success"
        >
          Signature cropped. Remember to click <strong>Save</strong>.
        </p>
      </div>
    </div>

    <vs-divider class="mb-3 pt-0" id="not-img-cropper"></vs-divider>
    <div class="vx-row" id="not-img-cropper">
      <vs-spacer></vs-spacer>
      <div class="vx-col">
        <vx-card class="mb-4 glow-effect_dark card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div
                class="prepend-text glow-effect_dark grade-symbol input-group_prepend-slot-bg"
              >
                <span
                  ><feather-icon
                    class="pt-3"
                    icon="CheckIcon"
                    svg-classes="stroke-current"
                  ></feather-icon
                ></span>
              </div>
            </template>

            <vs-button
              size="large"
              ref="saveButton"
              class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
              style="border-radius: 0 7px 7px 0"
              @click="saveChanges"
            >
              Save Changes
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import vueFilePond, {setOptions } from 'vue-filepond';
  import FilePondPluginFileRename from 'filepond-plugin-file-rename';
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
  const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview,FilePondPluginFileRename);


  setOptions({
    fileRenameFunction: (file) => {
      var siteName = "Temp";
      if(localStorage.getItem('userSiteInfo') != ""){
        if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
          siteName = JSON.parse(localStorage.getItem('userSiteInfo'))[0].name;
        else 
          siteName = JSON.parse(localStorage.getItem('userSiteInfo')).name;
      }
      var studentName = "";
      if(localStorage.getItem('userInfo') != ""){
        studentName = JSON.parse(localStorage.getItem('userInfo')).displayName;
      }
      return `${siteName}_Signature_${studentName.replace(' ','_')}.png`;
    }
  });


import vSelect from "vue-select";
import { WebCam } from "vue-web-cam";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import VueSignaturePad from "vue-signature-pad";
export default {
  components: {
    vSelect,
    WebCam,
    VueCropper,
    VueSignaturePad,
    FilePond
  },
  props: {},
  data() {
    return {
      formData: {
        id: 0,
        userFirstName: "",
        userLastName: "",
        work: "",
        mobile: "",
        email: "",
        isActive: false,
        site: [],
        uploadedFileName: "",
        isStudent: true,
        idNumber: "",
        password: "",
        passwordConfirm: "",
        companyName: "",
        languageId: null,
        courseClassificationId: null,
        signatureImageUrl: "",
      },
      isLoading: false,
      changePassword: false,
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      frontCam: true,
      WebCam: false,
      languageDropdown: 0,
      classificationDropdown: 0,
      languages: [],
      classifications: [],
      currentSiteTypeId: null,
      cropImg: null,
      newSignatureClicked: false,
      signature: "",
      showCropImage: false,
      tempData: null,
      showSignaturePad: false,
      currentWindowWidth: window.innerWidth,
    };
  },
  computed: {
    device: function () {
      return find(this.devices, (n) => n.deviceId == this.deviceId);
    },
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    },
},
  watch: {
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      if (typeof window.orientation === "undefined") {
        // Once we have a list select the first one
        let first = this.devices[0];
        if (first) {
          this.camera = first.deviceId;
          this.deviceId = first.deviceId;
        }
      } else {
        this.frontCam = false;
      }
    },
  },
  methods: {
    loadData() {
      var self = this;
      self.showLoadingOnElement("profilerow", 1, "corners");

      var onSuccess = function (response) {
        self.formData.id = response.data.id;
        self.formData.userFirstName = response.data.userFirstName;
        self.formData.userLastName = response.data.userLastName;
        self.formData.work = response.data.work;
        self.formData.mobile = response.data.mobile;
        self.formData.uploadedFileName = response.data.imageUrl;
        self.formData.email = response.data.email;
        self.formData.isActive = response.data.isActive;
        self.formData.idNumber = response.data.idNumber;
        // self.formData.password = response.data.password;
        // self.formData.passwordConfirm = response.data.password;
        //self.formData.companyName = response.data.companyName;
        self.formData.signatureImageUrl = response.data.signatureImageUrl;
        self.signature = response.data.signatureImageUrl;

        self.formData.site = JSON.parse(localStorage.getItem("userSiteInfo"))[0];
        self.getLanguages(function () {
          self.languageDropdown = self.languages.filter(function (item) {
            return item.value == response.data.languageId;
          })[0];
          self.getClassifications(function () {
            self.classificationDropdown = self.classifications.filter(function (item) {
              return item.value == response.data.courseClassificationId;
            })[0];
          });
        });

        self.currentSiteTypeId = response.data.siteTypeId;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.profilerow.$el);
      };

      self.$ajaxGet(self, "Student/GetInfo", onSuccess, onFinally);
    },
    saveChanges() {
      var self = this;

      if (self.formData.signatureImageUrl) {
        if (self.formData.signatureImageUrl.includes("https://")) {
          self.saveChangesWithRigthSignature();
          var userSiteInfo;
          if (JSON.parse(localStorage.getItem("userSiteInfo")) instanceof Array) {
            userSiteInfo = JSON.parse(localStorage.getItem("userSiteInfo"));
            userSiteInfo[0].hasSignature = true;
            localStorage.setItem("userSiteInfo", JSON.stringify(userSiteInfo));
          } else {
            userSiteInfo = JSON.parse(localStorage.getItem("userSiteInfo"));
            userSiteInfo.hasSignature = true;
            localStorage.setItem("userSiteInfo", JSON.stringify(userSiteInfo));
          }
        } else {
          self.$vs.notify({
            title: "Attention",
            color: "warning",
            text: "Please crop signature image before saving",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info",
          });
        }
      } else {
        self.saveChangesWithRigthSignature();
      }
    },
    saveChangesWithRigthSignature() {
      var self = this;
      self.signature = null;
      self.$validator.validateAll().then((result) => {
        if (result) {
          self.showLoadingOnElement("saveButton", 0.45, "material");

          self.formData.languageId = self.languageDropdown
            ? parseInt(self.languageDropdown.value)
            : null;
          self.formData.courseClassificationId = self.classificationDropdown
            ? parseInt(self.classificationDropdown.value)
            : null;

          var onSuccess = (response) => {
            self.cropImg = null;
            self.newSignatureClicked = false;
            self.signature = self.formData.signatureImageUrl;
            self.$vs.notify({
              title: "Information",
              color: "success",
              text: "Changes Saved",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-save",
            });
          };
          var onFinally = function () {
            self.$vs.loading.close(self.$refs.saveButton.$el);
          };

          self.$ajaxPost(
            self,
            "student/savechanges",
            self.formData,
            onSuccess,
            onFinally
          );
        } else {
          self.$vs.notify({
            title: "Attention",
            color: "warning",
            text: self.$validator.errors.items[0].msg,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info",
          });
        }
      });
    },
    selectLanguage() {
      var self = this;
      if (!self.languageDropdown) return;
      self.getClassifications(function () {
        self.classificationDropdown = 0;
      });
    },
    getLanguages(whenDone) {
      var self = this;

      var onSuccess = (response) => {
        self.languages = response.data.map((item) => {
          return { label: item.text, value: item.value };
        });
        if (whenDone && typeof whenDone == "function") whenDone();
      };

      self.$ajaxGet(self, "language/GetSelectList", onSuccess);
    },
    getClassifications(whenDone) {
      var self = this;

      var onSuccess = (response) => {
        self.classifications = response.data.map((item) => {
          return { label: item.text, value: item.value };
        });
        if (whenDone && typeof whenDone == "function") whenDone();
      };
      if (self.languageDropdown)
        self.$ajaxGet(
          self,
          "courseclassification/GetSelectList/" + self.languageDropdown.value,
          onSuccess
        );
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale,
      });
    },
    successUpload(data) {
      this.formData.uploadedFileName = data[0].url;
      this.$vs.loading.close(this.$refs.fileUpload.$el);
      this.isLoading = false;
    },
    showUpload() {
      this.formData.uploadedFileName = null;
      this.WebCam = true;
    },
    showLoadingOnUploader() {
      var self = this;
      self.isLoading = true;
      self.$vs.loading({
        type: "material",
        container: self.$refs.fileUpload.$el,
        scale: 0.45,
      });
    },
    async onCapture() {
      this.img = await this.$refs.webcam.capture();

      var block = this.img.split(";");
      var contentType = block[0].split(":")[1];
      if (contentType != ",") {
        var realData = block[1].split(",")[1];
        var blob = await this.b64toBlob(realData, contentType);
        this.uploadSnapshot(blob);
      }
    },
    onSuccess() {
      this.$vs.dialog({
        color: "success",
        title: "Camera Accessed!",
        text: "Great! Now you can start!",
        acceptText: "Thanks",
      });
    },
    reloadPage() {
      this.$router.go();
    },
    onCameras(cameras) {
      this.devices = cameras;
      //this.onSuccess(); <-- for testing only
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = window.atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    uploadSnapshot(blob) {
      var self = this;
      var formData = new FormData();
      formData.append("image", blob, "student_" + self.formData.id + ".jpg");

      var onSuccess = (response) => {
        self.formData.uploadedFileName = response.data.url;
        self.WebCam = false;
      };

      self.$ajaxPost(self, "tempupload", formData, onSuccess);
    },
    cropImage() {
      var self = this;
      self.showLoadingOnElement("cropButton", 0.45, "corners");
      self.cropImg = self.$refs.cropper.getCroppedCanvas().toDataURL();

      var fileExt = self.cropImg.substring(
        self.cropImg.indexOf("/") + 1,
        self.cropImg.indexOf(";")
      );

      var byteString = atob(self.cropImg.split(",")[1]);
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);

      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      var blob = new Blob([ab], { type: "image/" + fileExt });

      var data = new FormData();
      data.append("image", blob, "signature_" + self.formData.id + "." + fileExt);

      var onSuccess = (response) => {
        self.formData.signatureImageUrl = response.data.url;
        self.showCropImage = true;
        self.$vs.loading.close(self.$refs.cropButton.$el);
        self.fixThisFknCropper();
      };

      self.$ajaxPost(self, "tempupload", data, onSuccess);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    reset() {
      this.cropImg = null;
      this.$refs.cropper.reset();
      this.fixThisFknCropper();
    },
    fixThisFknCropper() {
      this.$refs.cropper.cropper.options.minCanvasHeight = 60;
      this.$refs.cropper.cropper.options.minCanvasWidth = 60;
      this.$refs.cropper.cropper.options.minContainerHeight = 60;
      this.$refs.cropper.cropper.options.minContainerWidth = 60;
      this.$refs.cropper.cropper.options.minCropBoxHeight = 60;
      this.$refs.cropper.cropper.options.minCropBoxWidth = 60;
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    setImage(e) {
      const file = e;
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.formData.signatureImageUrl = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(this.formData.signatureImageUrl);
        };
        reader.readAsArrayBuffer(file);
        this.newSignatureClicked = true;
        this.fixThisFknCropper();
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    enableSignaturePad() {
      this.showSignaturePad = true;
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    save() {
      var self = this;
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if(isEmpty){
        self.$vs.notify({
          title:'Warning',
          color: "warning",
          text: "Signature Empty",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-upload',
        });
        return;
      }
      this.showLoadingOnElement("userInfoTab", 1, "corners");
      this.$refs.coverPagePond.addFile(data);
      
    },
    uploadCompleteCover(error, file){
      var self = this;
      var responseUrl = JSON.parse(file.serverId);
      if(responseUrl.url){
        var onSuccess = (response) => {
          if(response.data){
            self.signature = responseUrl.url
            self.showSignaturePad = false;
            self.$vs.notify({
              title:'Information',
              color: "success",
              text: "Signature Saved",
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-upload',
            });
          }
        };
        var onFinally = response =>{
          if(self.$refs.userInfoTab){
            self.$vs.loading.close(self.$refs.userInfoTab.$el);
          }
        }
        self.$ajaxGet(self, `profie/updateSignature?url=${responseUrl.url}`, onSuccess,onFinally);
      }
    },
    
  },
  mounted() {
    var self = this;
    self.loadData();
    self.getLanguages();

    self.fixThisFknCropper();
  },
};
</script>
<style lang="scss" scoped>
.new-signature-button-on-select {
  height: fit-content;
  margin-top: 14px;
  margin-right: 2px;
}



#cropsignatureimage {
  max-width: 250px;
  max-height: 150px;
}

@media screen and (max-width: 900px) {
  #signatureimage {
    width: 166%;
  }
  #cropsignatureimage {
    width: 100%;
  }
}

#profileimg {
  border-radius: 50%;
  padding: 2px;
  border: 1px solid #838383;
  background-color: rgb(255, 255, 255);
  /* max-width: 100px; */
}

.v-select {
  overflow: unset;
}

#modulesTable {
  .vs-table--header {
    display: flex;
    flex-wrap: wrap-reverse;
    > span {
      padding-inline-end: 30px;
      width: calc(100% - 200px);
    }
  }
}

#profilerow {
  align-items: center;
}

.text {
  border-radius: 50%;
  color: rgb(41, 41, 41);
  font-size: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
  text-shadow: 2px 2px 5px rgb(255, 255, 255);
}

.container_profile-pic:hover .overlay {
  opacity: 1;
  border-radius: 50%;
}

.container_profile-pic {
  position: relative;
  width: 50%;
  border-radius: 50%;
}

.overlay {
  border-radius: 50%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.5s ease;
}

.cropper-div {
  input[type="file"] {
    display: none;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 5px 0;
  }
  .header h2 {
    margin: 0;
  }
  .header a {
    text-decoration: none;
    color: black;
  }
  .cropper-area_tool {
    width: 60%;

    // img {
    //   width: 50px !important;
    // }
  }
  .cropper-area_buttons {
    width: 100%;
  }
  .actions {
    margin-top: 1rem;
    display: flex;
  }
  // .actions vs-button {

  //   padding: 5px 15px;
  //   background: #0062CC;
  //   color: white;
  //   text-decoration: none;
  //   border-radius: 3px;
  //   margin-right: 1rem;
  //   margin-bottom: 1rem;
  // }
  textarea {
    width: 100%;
    height: 100px;
  }
  .preview-area {
    width: 307px;
  }
  .preview-area p {
    font-size: 1.25rem;
    margin: 0;
    margin-bottom: 1rem;
  }
  .preview-area p:last-of-type {
    margin-top: 1rem;
  }
  .preview {
    width: 100%;
    height: calc(372px * (9 / 16));
    overflow: hidden;
  }
  .crop-placeholder {
    width: 100%;
    height: 200px;
    background: #ccc;
  }
  .cropped-image img {
    max-width: 100%;
  }
}
.signaturePadStyle {
  background: white;
}
</style>
